import angular from 'angular';

import ProfileService from './profile.service';
import PreferenceService from './preference.service';
import EmailVerificationService from './email-verification.service';
import CollaboratorService from './collaborator.service';

export default angular
    .module('application.service.user', [])
    .service('profileService', ProfileService)
    .service('preferenceService', PreferenceService)
    .service('emailVerificationService', EmailVerificationService)
    .service('collaboratorService', CollaboratorService);



// WEBPACK FOOTER //
// ./src/application/service/user/index.js